<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        sm="12"
        md="12"
        lg="12"
      >
    <base-material-card
      color="primary"
      icon="mdi-home-analytics"
      inline
      title="Estate Wide Balance Report"
    >
      <v-data-table
        :headers="locationHeaders"
        :items="locations"
        :items-per-page="10"
      >
        <template v-slot:item.balance="{ item }">
          <v-btn class="ma-2" color="primary" :to="'/ReportBalance/' + item.idnum" dark>View
            <v-icon dark right>mdi-clock</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.cashin="{ item }">
          <v-btn class="ma-2" color="primary" :to="'/reportcashin/' + item.idnum" dark>View
            <v-icon dark right>mdi-cash-plus</v-icon>
          </v-btn>
        </template>        
      </v-data-table>
    </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Locations',

    data () {
      return {
        chartOptions: {
          chart: {
            id: 'vuechart-example'
          },
          xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
          }
        },
        series: [{
          name: 'series-1',
          data: [30, 40, 35, 50, 49, 60, 70, 91]
        }],
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        locationHeaders: [
          {
            sortable: true,
            text: 'Sites ID',
            value: 'idnum'
          },
          {
            sortable: true,
            text: 'Number of Units on Site',
            value: 'safeids.length',
            align: 'center'
          },
          {
            sortable: true,
            value: 'balance',
            align: 'center',
            text: 'Current Cash Balances'
          },
          {
            align: 'center',
            sortable: true,
            value: 'cashin',
            text: 'Cash In per Day Reports'
          },
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    created () {
      this.locations = []
      for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
        // this.$log.debug(`${key}: ${value}`)
        if (value.siteunitsprofile) {
          let shop = {
            idnum: key,
            safeids: value.siteunitsprofile
          }
          this.locations.push(shop)
        }
        // this.$log.debug(key,value.siteunitsprofile)
      }
      this.$log.debug('our location map ', this.locations)
      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
    },
    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
